import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import { Card, Container, Row, Col } from "react-bootstrap";
import "./AgentHub.css";
import api from "../../services/api";

const AgentHub = () => {
  const [agents, setAgents] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAgents();
  }, []);

  const fetchAgents = async () => {
    try {
      const response = await api.get("/api/agents");
      setAgents(response.data);
    } catch (error) {
      console.error("Error fetching agents:", error);
    }
  };

  const handleAgentSelect = (agentType) => {
    navigate(`/agent/${agentType}`);
  };

  return (
    <Container className="agent-hub-container">
      <h1 className="text-center mb-4">Educational Agents</h1>
      <Row>
        {Object.entries(agents).map(([type, agent]) => (
          <Col key={type} xs={12} md={6} lg={4} className="mb-4">
            <Card
              className="agent-card h-100"
              onClick={() => handleAgentSelect(type)}
            >
              <Card.Body>
                <Card.Title>{agent.name}</Card.Title>
                <Card.Text>{agent.description}</Card.Text>
                <div className="capabilities">
                  <h6>Capabilities:</h6>
                  <ul>
                    {agent.capabilities.map((capability, index) => (
                      <li key={index}>{capability}</li>
                    ))}
                  </ul>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

// Wrap in the shared layout so the page has the site header and footer
const AgentHubPage = (props) => (
  <Layout>
    <AgentHub {...props} />
  </Layout>
);

export default AgentHubPage;
